import configLib from '../../../configLib';
import { measurePerf } from '../../debug/performance';
import { parsingResponseFailed } from '../../store/gateway';
import { updateSymbolStatusCache } from '../../store-util/SymbolStatusCache';
import { parseGatewayData } from '../../util/GatewayHelpers';
import { dataArrayToMap } from '../../util/MarketDataHelpers';
import { WebSocketEventData } from '../custom-event/types';
import { LoggerService } from '../logger/Logger.service';
import { GatewayRequestType, GatewayResponseSubType, GatewayResponseType } from '../web-socket/types';

import { BaseSymbolSubscriptionService } from './BaseSymbolSubscription.service';
import { SymbolSubscriptionRequestType } from './types';

const LOG_PREFIX = '[SS-SUBS]';
const logger = LoggerService.getLogger();

/**
 * Foreign Exchange Subscription Service
 */
export class SymbolStatusSubscriptionService extends BaseSymbolSubscriptionService<SymbolSubscriptionRequestType> {
  private static instance: SymbolStatusSubscriptionService | undefined;

  // Make the constructor private, to have a single instance
  // eslint-disable-next-line no-useless-constructor
  private constructor() {
    super();
  }

  static getInstance(): SymbolStatusSubscriptionService {
    this.instance ??= new SymbolStatusSubscriptionService();
    return this.instance;
  }

  public handleResponseEvent = (event: WebSocketEventData<any>): void => {
    if (event.data.messageSubType !== GatewayResponseSubType.SymbolStatus) {
      return;
    }
    const data = event.data ?? {};
    let parsedData;

    try {
      parsedData = measurePerf('symbolStatus.parseGatewayData', undefined, () => parseGatewayData(data.arrayData));
    } catch (error) {
      configLib.store.dispatch(parsingResponseFailed(`${error}`));
      return;
    }

    logger.log(`${LOG_PREFIX} SymbolStatusSubscriptionService response! data:`, event);

    parsedData = {
      raw: data,
      final: dataArrayToMap(parsedData),
    };

    updateSymbolStatusCache(parsedData.final);
  };

  protected shouldHandleResponse(event: WebSocketEventData<any>): boolean {
    return event.data?.messageSubType === GatewayResponseSubType.SymbolStatus;
  }

  protected getResponseType(): GatewayResponseType {
    return GatewayResponseType.MarketData;
  }

  protected getSubscriptionRequestType(): GatewayRequestType {
    return GatewayRequestType.MarketDataSubscribeSymbolStatus;
  }

  protected getUnsubscriptionRequestType(): GatewayRequestType {
    return GatewayRequestType.MarketDataUnsubscribeSymbolStatus;
  }
}
